import React, { Component } from 'react';
import {Button} from "react-bootstrap";
import {FacebookShareButton, LinkedinShareButton, TwitterShareButton} from "react-share";
import {bootstrapUtils} from "react-bootstrap/lib/utils";
bootstrapUtils.addStyle(Button, 'twitter');
bootstrapUtils.addStyle(Button, 'linkedIn');
export default class SocialShare extends Component {
  render() {
    return (
      <div style={this.props.style}>
        <LinkedinShareButton url={this.props.url} title={this.props.title}>
          <Button bsStyle="linkedIn" bsSize={this.props.size}>
            <i className="fa fa-linkedin-square fa-fw" aria-hidden="true"/> Share on LinkedIn
          </Button>
        </LinkedinShareButton>
        <FacebookShareButton url={this.props.url} quote={this.props.title} hashtag="#AWSCertified">
          <Button bsStyle="primary" bsSize={this.props.size}>
            <i className="fa fa-facebook-square fa-fw" aria-hidden="true"/> Share on Facebook
          </Button>
        </FacebookShareButton>
        <TwitterShareButton url={this.props.url} title={this.props.title} hashtags={['AWSCertified', 'AWS', 'AWSDirectory', 'AWSCertification']} via="JasperThayer">
          <Button bsStyle="twitter" bsSize={this.props.size}>
            <i className="fa fa-twitter-square fa-fw" aria-hidden="true"/> Share on Twitter
          </Button>
        </TwitterShareButton>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Marketing/SocialShare.js